import { PageKey } from '~/constants/page';
import type { Nav } from '~/hooks/useNav';
import { HOME_ROUTE_LIST } from '~/utils/permission';

const getRouteName = (routeName: unknown) => {
  return typeof routeName === 'string' ? routeName : '';
};

const isNavSelfActive = (nav: Nav, routeName: string, routePath: string) => {
  if (nav.activePageKeys?.length) {
    return nav.activePageKeys.some(
      pageKey => routeName === pageKey || routeName.startsWith(`${pageKey}-`),
    );
  }

  if (nav.pageKey === PageKey.PRIME) {
    return HOME_ROUTE_LIST.includes(routeName as PageKey);
  }

  if (nav.pageKey) {
    return routeName === nav.pageKey || routeName.startsWith(`${nav.pageKey}-`);
  }

  if (nav.route) {
    return routePath === nav.route;
  }

  return false;
};

export const getNavActiveKey = (
  nav: Pick<Nav, 'pageKey' | 'route' | 'link' | 'name' | 'activePageKeys'>,
) => {
  return nav.pageKey || nav.route || nav.link || nav.name;
};

export const collectActiveNavKeys = (navs: Nav[], routeName: unknown, routePath: string) => {
  const normalizedRouteName = getRouteName(routeName);
  const activeKeys = new Set<string>();

  const visit = (nav: Nav) => {
    const isChildActive = nav.children?.some(child => visit(child)) || false;
    const isSelfActive = isNavSelfActive(nav, normalizedRouteName, routePath);
    const isActive = isSelfActive || isChildActive;

    if (isActive) {
      activeKeys.add(getNavActiveKey(nav));
    }

    return isActive;
  };

  navs.forEach(visit);

  return activeKeys;
};
